import React, { memo, useCallback, useContext, useMemo } from 'react'
import { Grid, Box } from '@mui/material'
import { AnyAutocomplete, AutocompleteOption } from '../anyform'
import { translate } from '../i18n'
import { AppContext } from './AppContext'

function TenantSwitch() {
    const context = useContext(AppContext)
    const id = context.session?.tenant?.id || ''

    const options = useMemo<AutocompleteOption[]>(() => {
        return (
            context.session?.accesses.map((access) => ({
                value: access.tenant_id,
                label: access.name || (translate('app.platform') as string),
            })) ?? []
        )
    }, [context])

    const changeTenant = useCallback(
        (name: string, value?: string) => {
            const tenant = context.session!.tenant
            const segments = value?.split('__') ?? []
            const tenantId = segments.length > 0 ? segments[0] : ''

            if (tenant) {
                if (tenant.id === tenantId) {
                    return
                }
            } else if (!tenantId) {
                return
            }

            context.onChangedTenant(tenantId)
        },
        [context]
    )

    return (
        <Box py={2}>
            <Grid container justifyContent="center">
                <Grid item xs={10}>
                    <AnyAutocomplete
                        variant="filled"
                        name="tenant_picker"
                        label={translate('app.switch') as string}
                        initialValue={id}
                        options={options}
                        disableClearable
                        register={() => {}}
                        notifier={changeTenant}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default memo(TenantSwitch)
